import * as firebase from 'firebase'
import moment from 'moment'
import { when } from 'ramda'

const generateShifts = (rotaId, start, end, pattern) => {
  const startDate = moment(start).format()
  const endDate = moment(end).format()

  const shifts = calculateShifts(startDate, endDate, pattern);
  return createShifts(rotaId, shifts)
}

const createShifts = (rotaId, shifts) => {
  return new Promise(resolve => {
    const uid = firebase.auth().currentUser.uid

    const shiftsRef   = firebase.database().ref('shifts')
    const accShiftRef = firebase.database().ref(`accounts/${uid}/shifts`)
    const accRotasRef = firebase.database().ref(`rotas/${rotaId}/shifts`)

    shifts.forEach(shift => {
      const [startString, endString] = shift

      const firebaseShift = {
        account: uid,
        startDate: moment(startString).format(),
        endDate: moment(endString).format()
      }

      const newShiftRef = shiftsRef.push()
      const id = newShiftRef.key

      newShiftRef.set(firebaseShift)
      accRotasRef.child(id).set(true)
      accShiftRef.child(id).set(true)
    });
    resolve()
  })
}

const calculateShifts = (startDate, endDate, pattern) => {
  const startMoment = moment(startDate)
  const endMoment = moment(endDate)

  if (!startMoment.isValid()) throw new Error(`Invalid start date: ${startDate}`)
  if (!endMoment.isValid()) throw new Error(`Invalid end date: ${endDate}`)

  const splitPattern = pattern.split(',')

  if (splitPattern.length % 2 !== 0) throw new Error(`Invalid pattern: ${pattern}`)

  const throwIfNaN = number => when(isNaN, () => { throw new Error(`Invalid pattern, contains non int section: ${number}`)})(number)
  splitPattern.forEach(throwIfNaN)

  let shifts = [];
  let i = 0;
  let currentMoment = startMoment;

  console.log(currentMoment, endMoment, pattern)

  while(currentMoment < endMoment) {
    const shiftStartMoment = currentMoment;
    const shiftEndMoment = moment(shiftStartMoment).add(splitPattern[i], 'days');

    if ((i % 2) === 0) {
      const shift = [shiftStartMoment.format(), shiftEndMoment.format()]
      shifts.push(shift);
    }

    currentMoment = shiftEndMoment;

    i += 1;
    if (i >= splitPattern.length) {
      i = 0;
    }
  }
  return shifts;
};

export default generateShifts



// WEBPACK FOOTER //
// ./src/generate-shifts.js